import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

import { BasicInputTypeEnum } from '../../../enums/basic-input-type.enum';

@Component({
    selector: 'app-schedules',
    templateUrl: './schedules.component.html',
    styleUrls: ['./schedules.component.scss'],
})
export class SchedulesComponent {
    @Input() public id?: string;
    @Input() public control: FormArray;
    @Input() public startTimePlaceholder = 'REPERTOIRE.FORMS.SCHEDULES.START-TIME-PLACEHOLDER';
    @Input() public endTimePlaceholder = 'REPERTOIRE.FORMS.SCHEDULES.END-TIME-PLACEHOLDER';
    @Input() public readonly = false;

    @Output() public elementSizeModification = new EventEmitter<void>();

    public basicInputTypeEnum = BasicInputTypeEnum;

    public get monday(): FormGroup {
        return this.control.at(0) as FormGroup;
    }

    public get tuesday(): FormGroup {
        return this.control.at(1) as FormGroup;
    }

    public get wednesday(): FormGroup {
        return this.control.at(2) as FormGroup;
    }

    public get thursday(): FormGroup {
        return this.control.at(3) as FormGroup;
    }

    public get friday(): FormGroup {
        return this.control.at(4) as FormGroup;
    }
}
